<div class="flex-fill d-flex flex-column">
    <div class="flex-fill d-flex m-1" style="max-height: 50px">
        <div class="col-sm-1 ms-10">
            <div class="dx-field-label" style="overflow: unset; text-overflow: unset">Select Statuses</div>
        </div>
        <div class="col-sm-3 ms-10">
            <dx-tag-box [items]="statusList" [(value)]="selectedStatuses" [showSelectionControls]="true" displayExpr="name" valueExpr="id"></dx-tag-box>
        </div>
        <div class="col-sm-2 ps-0">
            <button class="btn btn-success" (click)="searchByStatus()">Search</button>
        </div>
    </div>

    <div class="flex-fill d-flex">
        <div class="col-sm-7 flex-fill d-flex">
            <div class="m-1 grid-fill" *ngIf="parts">
                <dx-data-grid
                    #dataGrid
                    [keyExpr]="'partId'"
                    [dataSource]="parts"
                    [showBorders]="true"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onSelectionChanged)="selectionChange($event)"
                    (onOptionChanged)="onOptionChanged($event)"
                    (onContentReady)="onContentReady($event)"
                    (onRowPrepared)="rowPrepare($event)"
                    (onExporting)="onExporting($event)"
                >
                    <dxi-column dataField="partNumber" caption="Part #" width="300" cellTemplate="partNumberTemplate"></dxi-column>
                    <dxi-column dataField="mfgPartNumber" caption="MfgPart #" width="200"></dxi-column>
                    <dxi-column dataField="orderCount" caption="StatusCount" width="80"></dxi-column>

                    <dxi-column dataField="inStock" caption="InStock" width="80"></dxi-column>
                    <dxi-column dataField="partsAllocated" caption="Allocated" width="80"></dxi-column>
                    <dxi-column dataField="projectedInventory" caption="Prj. Inv." width="80"></dxi-column>

                    <dxi-column dataField="onOrder" caption="PartsOnOrder" width="80" cellTemplate="poTemplate"></dxi-column>
                    <dxi-column dataField="weldShopPI" caption="Weld Shop Proj." width="80"></dxi-column>

                    <dxi-column dataField="statusName" width="180"></dxi-column>
                    <dxi-column width="300"></dxi-column>

                    <div *dxTemplate="let cell of 'partNumberTemplate'">
                        <a [routerLink]="[]" (click)="partDetailDialog(cell.data.partId)">{{ cell.value || '' }}</a>
                    </div>

                    <div *dxTemplate="let cell of 'poTemplate'">
                        <a [routerLink]="[]" (click)="purchaseOrderDialog(cell.data.partId)">{{ cell.value || '' }}</a>
                    </div>

                    <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-selection [mode]="'single'"></dxo-selection>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="parts-overview-grid"></dxo-state-storing>

                    <div *dxTemplate="let data of 'toolbarButtons'"></div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="parts" class="me-3"
                            ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                        >
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="col-sm-5 flex-fill d-flex">
            <div class="m-1 grid-fill" *ngIf="partInfos">
                <dx-data-grid
                    #detailGrid
                    [dataSource]="partInfos"
                    [showBorders]="true"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onSelectionChanged)="detailSelectionChange($event)"
                    (onOptionChanged)="onDetailOptionChanged($event)"
                    (onContentReady)="onDetailContentReady($event)"
                    (onExporting)="onExporting($event)"
                >
                    <dxi-column dataField="salesOrder" caption="SO #" width="100" cellTemplate="linkTemplate"></dxi-column>
                    <dxi-column dataField="companyName" caption="Dealer"></dxi-column>
                    <dxi-column dataField="partNumber" caption="Part #" width="300" cellTemplate="detailPartNumberTemplate"></dxi-column>
                    <dxi-column dataField="parentPart" caption="Parent Part" width="300"></dxi-column>
                    <dxi-column dataField="quantity" width="80"></dxi-column>
                    <dxi-column dataField="status" width="180"></dxi-column>
                    <dxi-column dataField="salesOrderDate" caption="Sales Order Date" dataType="date" width="180"></dxi-column>

                    <div *dxTemplate="let cell of 'linkTemplate'">
                        <a [routerLink]="[]" (click)="open(cell.data.orderId)">{{ cell.value || '' }}</a>
                    </div>

                    <div *dxTemplate="let cell of 'detailPartNumberTemplate'">
                        <a [routerLink]="[]" (click)="partDetailDialog(cell.data.partId)">{{ cell.value || '' }}</a>
                    </div>

                    <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-selection [mode]="'multiple'"></dxo-selection>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="parts-overview-salesOrder-grid"></dxo-state-storing>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <!-- <button type="button" class="btn btn-sm btn-primary me-4" (click)="markAsBackOrdered()" [hidden]="purchaseOrder.statusId !== 3">Mark As BackOrdered</button> -->
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="partInfos" class="me-3"
                            ><strong>{{ detailGrid.instance.totalCount() + ' items' }}</strong></span
                        >
                    </div>
                </dx-data-grid>
            </div>
            <div class="main-toolbar">
                <div class="col-sm-12 text-end">
                    <label class="m-r sum-label"> Selected Sum:</label>
                    <label class="m-r sum-label"> {{ selectedSum }}</label>
                </div>
            </div>
        </div>
    </div>
</div>
